import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API } from "../backend";
import authHeader from "../services/auth-header";
import axios from "axios";
import AuthService from "../services/auth.service";
import CompanySwitchService from "../services/company/companySwitchService";
import { getTrans as t } from "../Localization/translations";
import GetCompanyInfoService from "../services/company/getCompanyInfoService";
import { IMAGE } from "../backend";
import { useProSidebar } from "react-pro-sidebar";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import Model from "../Supportticket/model";
import NotesAll from "./Notes/NotesAll";
import NotesSingle from "./Notes/NotesSingle";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import Badge from "@material-ui/core/Badge";

function Navigation({
  setMenuShowHide,
  menuShowHide,
  customerPermission,
  profileImage,
  customData,
  notesLength,
  setRtl,
}) {
  const [planFeatures, setPlanFeatures] = useState(null);
  const [query, setQuery] = useState("");
  const [image, setImage] = useState("");
  const [showhide, setShowHide] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [options2, setOptions2] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [state, setState] = useState("");
  const [contract_type, setContract_type] = useState("");
  // const [notesFromDropdown, setNotesFromDropdown] = useState(false); // OLD LOGIC COMMENTED
  const [notesPanelType, setNotesPanelType] = useState(""); // 'all', 'single', ''
  const path = useLocation();
  const [showSupportSubmenu, setShowSupportSubmenu] = useState(false);
  const [showAccountSubmenu, setShowAccountSubmenu] = useState(false);

  const [pendingApprovals, setPendingApprovals] = useState(0);

  // ── Company Switcher ──
  const [accessibleCompanies, setAccessibleCompanies] = useState(
    CompanySwitchService.getAccessibleCompanies(),
  );
  const [activeCompanyName, setActiveCompanyName] = useState(
    localStorage.getItem("active_company_name") ||
      localStorage.getItem("companyid"),
  );
  const [switching, setSwitching] = useState(false);
  const [isSwitched, setIsSwitched] = useState(
    CompanySwitchService.isSwitched(),
  );
  const [switchedFromName, setSwitchedFromName] = useState(
    localStorage.getItem("switched_from_company_name") || "",
  );
  const [showAccountMenu, setShowAccountMenu]     = useState(false);
  const [loadingCompanies, setLoadingCompanies]   = useState(false);
  const [switchError, setSwitchError]             = useState("");
  const accountMenuRef = useRef(null);
  const accountSubTimeoutRef = useRef(null);

  const refreshCompanySwitcherState = () => {
    setAccessibleCompanies(CompanySwitchService.getAccessibleCompanies());
    setActiveCompanyName(
      localStorage.getItem("active_company_name") ||
        localStorage.getItem("companyid") ||
        "",
    );
    setIsSwitched(CompanySwitchService.isSwitched());
    setSwitchedFromName(localStorage.getItem("switched_from_company_name") || "");
  };

  // Fetch live company list from API every time the menu opens
  const fetchLiveCompanies = async () => {
    setLoadingCompanies(true);
    try {
      const res = await CompanySwitchService.listMyClients();
      const clients = res.data?.clients || [];
      // Normalise to the same shape stored in localStorage accessible_companies
      const liveList = clients.map((c) => ({
        company_id:            c.company_id || c.id,
        company__company_name: c.company_name,
        role:                  c.role || c.relationship_type || "client",
        relationship_type:     c.relationship_type || "child",
      }));
      setAccessibleCompanies(liveList);
      // Also keep localStorage in sync for offline use
      localStorage.setItem("accessible_companies", JSON.stringify(liveList));
    } catch (e) {
      // Fall back to cached value silently
    } finally {
      setLoadingCompanies(false);
    }
  };

  const handleMenuOpen = () => {
    setShowAccountMenu(true);
    fetchLiveCompanies();
  };

  // Account submenu — delayed open/close so mouse can travel to the panel without it closing
  const openAccountSub = () => {
    clearTimeout(accountSubTimeoutRef.current);
    setShowAccountSubmenu(true);
    setSwitchError("");
    fetchLiveCompanies();
  };
  const closeAccountSub = () => {
    accountSubTimeoutRef.current = setTimeout(() => setShowAccountSubmenu(false), 180);
  };

  // Close when clicking outside on mobile / touch devices
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (accountMenuRef.current && !accountMenuRef.current.contains(e.target)) {
        setShowAccountMenu(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handleSwitchCompany = async (companyId) => {
    if (String(companyId) === String(localStorage.getItem("active_company_id")))
      return;

    // Look up what kind of company this is in the current list.
    // relationship_type is set by the backend list_my_clients:
    //   'parent'  → root parent of the current company
    //   'sibling' → another child of the same parent
    //   'self'    → currently active (should not be clickable, but guard anyway)
    //   anything else ('managed', 'client'…) → direct child of current company
    const entry   = accessibleCompanies.find(c => String(c.company_id) === String(companyId));
    const relType = entry?.relationship_type;

    if (relType === "self") return;

    setSwitching(true);
    try {
      if (relType === "parent" && CompanySwitchService.isSwitched()) {
        // Clicking the root parent while inside a switched session = switch back.
        const restoredUser = await CompanySwitchService.switchBack();
        if (restoredUser) {
          refreshCompanySwitcherState();
          window.location.href = "/";
        }
        return;
      }

      if (relType === "sibling" && CompanySwitchService.isSwitched()) {
        // Siblings require the original (parent) JWT.
        // Restore the original session synchronously (no reload), then switch.
        CompanySwitchService.switchBack();
      }

      // For parent (not yet switched), siblings (not switched), and own direct
      // children: call switchCompany with whichever token is now in localStorage.
      // The backend allows these via is_family_access or UserCompanyAccess.
      const res = await CompanySwitchService.switchCompany(companyId);
      if (res.success === 1) {
        refreshCompanySwitcherState();
        window.location.href = "/";
      } else {
        const detail = res.detail ? ` | caller:${res.detail.caller_company} parents:[${res.detail.parent_ids_found}]` : "";
        setSwitchError((res.error || "Switch failed") + detail);
      }
    } catch (e) {
      const errData  = e?.response?.data;
      const detail   = errData?.detail ? ` | caller:${errData.detail.caller_company} parents:[${errData.detail.parent_ids_found}]` : "";
      const msg      = (errData?.error || e?.message || "Switch failed") + detail;
      setSwitchError(msg);
      console.error("Switch failed", e);
    } finally {
      setSwitching(false);
    }
  };

  const handleSwitchBack = async () => {
    setSwitching(true);
    try {
      const restoredUser = await CompanySwitchService.switchBack();
      if (restoredUser) {
        refreshCompanySwitcherState();
        window.location.href = "/";
      }
    } catch (e) {
      console.error("Switch back failed", e);
    } finally {
      setSwitching(false);
    }
  };

  let parent = localStorage.getItem("parent");
  let navigate = useNavigate();
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions"),
  );
  const [permissionsArray, setPermissionsArray] = useState(
    permissionss ? permissionss.split(",") : [],
  );
  const location = useLocation();

  useEffect(() => {
    const fetchSubscriptionFeatures = async () => {
      try {
        const response = await axios.get(`${API}paymentsub/subscription/`, {
          headers: authHeader(),
        });

        if (response.data.success === 1 && response.data.data) {
          setPlanFeatures(response.data.data.plan);
        }
      } catch (error) {
        console.error("Error fetching subscription features:", error);
      }
    };
    fetchSubscriptionFeatures();
  }, []);
  const isApiDisabled =
    planFeatures !== null && planFeatures.api_integration === false;
  const isApprovalDisabled =
    planFeatures !== null && planFeatures.approvals === false;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  useEffect(() => {
    const pathh = location.pathname;
    if (pathh === "/user") {
      const value = localStorage.getItem("permissions");
      setPermission(localStorage.getItem("permissions"));
      setPermissionsArray(value ? value.split(",") : []);
    }
  }, [location]);

  const handelDefault = () => {
    if (customerPermission !== "Customer") {
      GetCompanyInfoService.getCompanyInfo().then((response) => {
        localStorage.setItem("companyName", response.data.company_name);
        setImage(response.data.image);
      });
    } else if (customerPermission === "Customer") {
      GetCompanyInfoService.getCompanyProfileImage().then((response) => {
        setImage(response.data.image);
        if (response.data.company_name) {
      setActiveCompanyName(response.data.company_name);
      localStorage.setItem(
        "active_company_name",
        response.data.company_name
      );}
      });
    }
  };

  useEffect(() => {
    setShowHide(parent);
    Autologout();

    handelDefault();
  }, []);

  useEffect(() => {
    if (profileImage === true) {
      handelDefault();
    }
  }, [profileImage, image]);

  const handleSearch = () => {
    if (query !== "") {
      navigate("/globalsearch", { state: query });
      setQuery("");
    } else {
      return false;
    }
  };

  const logOut = () => {
    AuthService.logout()
      .then(() => {
        // navigate("/");
        window.location.href = "/";
      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  };

  const Autologout = () => {};

  const handleContractNavigation = (path, { state }) => {
    navigate(path, { state });
  };

  const handleShow = () => {
    setMenuShowHide(true);
    navigate("/settings");
    setRtl(false);
  };
  const { toggleSidebar } = useProSidebar();

  const handleClick = () => {
    setShowTooltip(!showTooltip);
    setModalVisible(true);
  };

  // NEW BLUE TICKET HANDLER - SEPARATE LOGIC
  const handleNewTicketClick = () => {
    // Navigate based on user type for new ticket system
    if (customerPermission === "Customer") {
      navigate("/customerticket");
    } else {
      navigate("/companyticket");
    }
  };

  const handlecontractLoan = ({ state }) => {
    navigate("/create-loan", { state });
  };

  const handlecontractLease = ({ state }) => {
    navigate("/create-lease", { state });
  };

  const handlecontractRent = ({ state }) => {
    navigate("/create-rental", { state });
  };

  // useEffect(() => {
  //   GetCompanyInfoService.getCompanySettingInfo().then(
  //     (response) => {
  //       setContract_type(response.data.contract_type)
  //     }
  //   )
  // }, [])

  // Helper to determine if current path needs NotesSingle panel
  const isSingleNotesPage = () =>
    path.pathname === "/party/details" ||
    path.pathname === "/editparty" ||
    path.pathname === "/editloancontract" ||
    path.pathname === "/contract/view" ||
    path.pathname === "/contract/edit" ||
    path.pathname === "/editrentalcontract" ||
    path.pathname === "/receipts/viewreceipts" ||
    path.pathname === "/receipts/editreceipts" ||
    path.pathname === "/billing/viewinvoices" ||
    path.pathname === "/billing/editinvoices";

  // Dropdown notes click: sets correct notes panel type for any page
  // OLD LOGIC COMMENTED BELOW:
  /*
  const handleNotesDropdownClickOld = () => {
    setIsSidePanelOpen(true);
    if (path.pathname === '/') {
      setNotesFromDropdown(true);
      setSelectedValue && setSelectedValue('');
      setOptions2 && setOptions2([]);
      setState && setState('');
    }
  };
  */
  // NEW LOGIC FOR ALL PAGES:
  const handleNotesDropdownClick = () => {
    setIsSidePanelOpen(true);
    // Home page = all, selected detail pages = single, fallback to all
    if (path.pathname === "/") {
      setNotesPanelType("all");
      setSelectedValue && setSelectedValue("");
      setOptions2 && setOptions2([]);
      setState && setState("");
    } else if (isSingleNotesPage()) {
      setNotesPanelType("single");
    } else {
      setNotesPanelType("all"); // fallback for other pages: open all notes
      setSelectedValue && setSelectedValue("");
      setOptions2 && setOptions2([]);
      setState && setState("");
    }
  };

  const loadPendingApprovals = async () => {
    try {
      const res = await axios.get(API + "approvals/tasks/", {
        headers: authHeader(),
      });

      const data = res.data || [];
      setPendingApprovals(data.length);
    } catch (err) {
      console.error("Approval count error", err);
    }
  };

  useEffect(() => {
    loadPendingApprovals();
  }, [location.pathname]);

  return (
    <>
      <style>
        {`
          .support-hover-dropdown > .support-submenu {
            display: none;
            position: absolute;
            right: 100%;
            top: -8px;
            min-width: 220px;
            margin: 0;
            padding: 6px 0;
            border: 1px solid #e9ecef;
            border-radius: 6px;
            box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
            background: #fff;
            z-index: 2000;
            padding-right: 4px;
          }

          .support-hover-dropdown:hover > .support-submenu {
            display: block;
          }

          .support-hover-dropdown:focus-within > .support-submenu {
            display: block;
          }

          .support-hover-dropdown.support-open > .support-submenu {
            display: block;
          }

          .support-hover-dropdown {
            position: relative;
          }

          .support-hover-dropdown .dropdown-item {
            color: #344767 !important;
            background: #fff;
            display: block;
            width: 100%;
            white-space: nowrap;
            font-size: 14px;
            padding: 8px 16px;
          }

          .support-hover-dropdown .dropdown-item:hover {
            color: #245C7F !important;
            background: #f8f9fa;
          }

          @media (max-width: 767.98px) {
            .support-hover-dropdown > .support-submenu {
              position: static;
              right: auto;
              top: auto;
              min-width: 100%;
              margin: 6px 0 0 0;
              box-shadow: none;
            }
          }

          /* ── Account hover submenu (same pattern as support) ── */
          .account-hover-dropdown > .account-submenu {
            display: none;
            position: absolute;
            right: 100%;
            top: -8px;
            min-width: 240px;
            margin: 0;
            padding: 6px 0;
            border: 1px solid #e9ecef;
            border-radius: 6px;
            box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
            background: #fff;
            z-index: 2000;
            /* Transparent right-side padding bridges any sub-pixel gap */
            padding-right: 4px;
          }

          .account-hover-dropdown:hover > .account-submenu {
            display: block;
          }

          .account-hover-dropdown:focus-within > .account-submenu {
            display: block;
          }

          .account-hover-dropdown.account-open > .account-submenu {
            display: block;
          }

          .account-hover-dropdown {
            position: relative;
          }

          .account-hover-dropdown .dropdown-item {
            color: #344767 !important;
            background: #fff;
            display: block;
            width: 100%;
            white-space: nowrap;
            font-size: 14px;
            padding: 8px 16px;
          }

          .account-hover-dropdown .dropdown-item:hover {
            color: #245C7F !important;
            background: #f8f9fa;
          }

          @media (max-width: 767.98px) {
            .account-hover-dropdown > .account-submenu {
              position: static;
              right: auto;
              top: auto;
              min-width: 100%;
              margin: 6px 0 0 0;
              box-shadow: none;
            }
          }
        `}
      </style>
      <nav
        className="navbar navbar-main navbar-expand-lg "
        id="navbarBlur"
        navbar-scroll="true"
      >
        <div className="container-fluid px-3 px-sm-3">
          <div
            className="s d-flex navbar-collapse mt-sm-0 ml-sm-5 me-md-0 me-sm-4"
            id="navbar"
          >
            <span
              className="nav-link text-body p-0"
              id="configureMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                className="fa fa-thin fa-bars d-lg-none fixed-plugin-button-nav cursor-pointer"
                onClick={() => toggleSidebar()}
              ></i>
            </span>
            <i
              className="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute right-0 top-0 d-none d-xl-none"
              aria-hidden="true"
              id="iconSidenav"
            ></i>
            <Link className="navbar-brand m-0" to="/">
              {image !== null ? (
                <img src={image} alt="Logo" className="im logo-mobile" />
              ) : (
                <img
                  src={process.env.PUBLIC_URL + "/static/images/logo.png"}
                  alt="Athena Fintech"
                  className="logo im logo-mobile"
                />
              )}
            </Link>
            <div className="ms-md-auto ps-md-3 d-flex flex-column flex-md-row align-items-end">
              {/* ── Company Switcher ── */}
              {/* {accessibleCompanies.length >= 1 && customerPermission !== "Customer" && (
                <div className="nav-item dropdown d-flex align-items-center me-3" style={{ position: "relative" }}>

                  {isSwitched && (
                    <span
                      style={{
                        background: "#fff3cd", border: "1px solid #ffc107",
                        borderRadius: "6px", padding: "3px 8px", fontSize: "12px",
                        marginRight: "8px", color: "#856404", cursor: "pointer",
                        display: "flex", alignItems: "center", gap: "5px"
                      }}
                      onClick={handleSwitchBack}
                      title={`Click to switch back to ${switchedFromName}`}
                    >
                      <i className="fa fa-arrow-left" style={{ fontSize: "10px" }}></i>
                      Back to {switchedFromName}
                    </span>
                  )}

                  <span
                    className="nav-link text-body p-0 d-flex align-items-center"
                    id="companySwitcherBtn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      cursor: "pointer", fontWeight: 600, fontSize: "14px",
                      color: isSwitched ? "#dc3545" : "#245C7F"
                    }}
                  >
                    <i className="fa fa-building me-1" style={{ fontSize: "13px" }}></i>
                    {switching ? "Switching..." : activeCompanyName}
                    {isSwitched && <small style={{ marginLeft: "4px", fontSize: "10px", color: "#dc3545" }}>▼</small>}
                    {!isSwitched && <i className="fa fa-chevron-down ms-1" style={{ fontSize: "10px" }}></i>}
                  </span>

                  <ul
                    className="dropdown-menu px-2 py-2"
                    aria-labelledby="companySwitcherBtn"
                    style={{ minWidth: "220px" }}
                  >
                    {isSwitched && (
                      <li className="mb-1">
                        <span
                          className="dropdown-item border-radius-md"
                          style={{ color: "#856404", background: "#fff3cd", cursor: "pointer", fontSize: "13px" }}
                          onClick={handleSwitchBack}
                        >
                          <i className="fa fa-arrow-left me-1"></i>
                          Switch back to {switchedFromName}
                        </span>
                        <hr style={{ margin: "6px 0" }} />
                      </li>
                    )}
                    {accessibleCompanies.map((c) => (
                      <li key={c.company_id} className="mb-1">
                        <span
                          className="dropdown-item border-radius-md d-flex justify-content-between align-items-center"
                          style={{
                            cursor: String(c.company_id) === String(localStorage.getItem("active_company_id")) ? "default" : "pointer",
                            fontWeight: String(c.company_id) === String(localStorage.getItem("active_company_id")) ? 700 : 400,
                            background: String(c.company_id) === String(localStorage.getItem("active_company_id")) ? "#e8f0fe" : "",
                          }}
                          onClick={() => handleSwitchCompany(c.company_id)}
                        >
                          <span>{c.company__company_name}</span>
                          <small style={{ color: "#888", marginLeft: "8px", textTransform: "capitalize" }}>
                            {c.role}
                          </small>
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )} */}

              <div className="bg-white border-radius-lg d-flex align-items-center w-100 w-md-auto">
                <input
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                  value={query}
                  name="q"
                  type="text"
                  className="form-control"
                  style={{ marginRight: "0.25rem", marginBottom: "0.25rem" }}
                  placeholder={t("Type here...")}
                />
              </div>
              <ul className="navbar-nav mb-2 mb-sm-0 ms-sm-auto justify-content-sm-end">
                <li className="nav-item d-flex  align-items-center">
                  {customerPermission !== "Customer" && (
                    <>

                  <li className="nav-item dropdown d-sm-block pe-2 px-4 d-flex align-items-center">
                    <span
                      className="nav-link text-body p-0"
                      onClick={() => {
                        if (isApprovalDisabled) return;
                        navigate("/approvals");
                      }}
                      style={{
                        cursor: isApprovalDisabled ? "not-allowed" : "pointer",
                        opacity: isApprovalDisabled ? 0.5 : 1,
                        filter: isApprovalDisabled ? "grayscale(100%)" : "none",
                      }}
                    >
                      <Badge
                        badgeContent={pendingApprovals}
                        color="secondary"
                        overlap="circular"
                        invisible={isApprovalDisabled || pendingApprovals === 0}
                        invisible={isApprovalDisabled || pendingApprovals === 0}
                      >
                        <VerifiedUserIcon
                          style={{
                            color: isApprovalDisabled ? "#9E9E9E" : "#245C7F",
                            fontSize: 26,
                          }}
                        />
                      </Badge>
                    </span>

                    {/* <ul
                      className="dropdown-menu px-2 py-3 ms-sm-n4"
                      aria-labelledby="configureMenuButton"
                    >
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_party") === true ? (
                          <Link
                            className="dropdown-item border-radius-md"
                            to="/addnewparty"
                          >
                            {t("New Party")}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_contract") === true ? (
                          <span className="dropdown-item border-radius-md">
                            {t("New Contract")} &raquo;{" "}
                          </span>
                        ) : (
                          ""
                        )}
                        <ul className="dropdown-item dropdown-submenu">
                          <span
                            className="dropdown-item"
                            onClick={() =>
                              handlecontractLease({ state: "Lease" })
                            }
                          >
                            {t("Lease")}
                          </span>
                          <span
                            className="dropdown-item"
                            onClick={() =>
                              handlecontractLoan({ state: "Loan" })
                            }
                          >
                            {t("Loan")}
                          </span>
                          <span
                            className="dropdown-item"
                            onClick={() =>
                              handlecontractRent({ state: "Rental" })
                            }
                          >
                            {t("Rental")}
                          </span>
                        </ul>
                      </li>
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_invoiceheader") ===
                          true ? (
                          <Link
                            className="dropdown-item"
                            to="/billing/createinvoices"
                          >
                            {t("New Invoice")}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_receipts") === true ? (
                          <Link
                            className="dropdown-item"
                            to="/receipts/createreceipts"
                          >
                            {t("New Receipt")}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                      {/* 
                          OLD NOTES BUTTON LOGIC (COMMENTED)
                        <li className="mb-2">
                          <span
                            className="dropdown-item"
                            onClick={() => {
                              setIsSidePanelOpen(true);
                              setNotesFromDropdown(path.pathname === '/');
                              setSelectedValue && setSelectedValue('');
                              setOptions2 && setOptions2([]);
                              setState && setState('');
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/assets/img/curved-images/icons8-sticky-notes-96.png"
                              }
                              alt="notes"
                              height='25px'
                              width='25px'
                              style={{ marginRight: "8px", verticalAlign: "middle" }}
                            />
                            {t("Notes")}
                          </span>
                        </li>
                        */}
                    {/* 
                          NEW NOTES BUTTON LOGIC FOR ALL PAGES 
                        */}
                    {/*                         
                      <li className="mb-2">
                        <span
                          className="dropdown-item"
                          onClick={handleNotesDropdownClick}
                        >
                          {/* <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/assets/img/curved-images/icons8-sticky-notes-96.png"
                              }
                              alt="notes"
                              height='25px'
                              width='25px'
                              style={{ marginRight: "8px", verticalAlign: "middle" }}
                            /> */}
                    {/* {t("New Note")} */}
                    {/* </span> */}
                    {/* </li> */}

                    {/* </ul>  */}

                  </li>
                  </>) }
                  
  

                  {accessibleCompanies.length >= 0 &&
                    // customerPermission !== "Customer" && 
                    (
                      <>
                        {/* {isSwitched && (
                          <span
                            style={{
                              background: "#fff3cd",
                              border: "1px solid #ffc107",
                              borderRadius: "6px",
                              padding: "3px 8px",
                              fontSize: "12px",
                              marginRight: "8px",
                              color: "#856404",
                              cursor: switching ? "not-allowed" : "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              opacity: switching ? 0.7 : 1,
                            }}
                            onClick={switching ? undefined : handleSwitchBack}
                            title={`Click to switch back to ${switchedFromName}`}
                          >
                            <i
                              className="fa fa-arrow-left"
                              style={{ fontSize: "10px" }}
                            ></i>
                            {switching
                              ? "Switching..."
                              : `Back to ${switchedFromName || "original company"}`}
                          </span>
                        )} */}

                      {/* ── Account Menu (click to open) ── */}
                      <li
                        className="nav-item d-flex align-items-center ms-3"
                        style={{ position: "relative" }}
                        ref={accountMenuRef}
                      >
                        {/* Trigger pill — shows Company Name + Plan badge */}
                        <div
                          className="company-switcher d-flex align-items-center px-3 py-2"
                          onClick={() => setShowAccountMenu((v) => !v)}
                          style={{
                            background: "#f5f7fb",
                            borderRadius: "12px",
                            cursor: "pointer",
                            border: "1px solid #e0e6ed",
                            userSelect: "none",
                          }}
                        >
                          <div className="me-2" style={{ maxWidth: "140px" }}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "14px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                color: "#344767",
                              }}
                              title={activeCompanyName}
                            >
                              {activeCompanyName || "My Company"}
                            </div>
                          </div>
                          <span
                            style={{
                              background: "#245C7F",
                              color: "#fff",
                              fontSize: "10px",
                              padding: "3px 8px",
                              borderRadius: "8px",
                              marginRight: "6px",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {planFeatures?.plan_name?.toUpperCase() || "FREE"}
                          </span>
                          <i
                            className="fa fa-chevron-down"
                            style={{
                              fontSize: "12px",
                              transition: "transform 0.2s",
                              transform: showAccountMenu ? "rotate(180deg)" : "rotate(0deg)",
                              color: "#6c757d",
                            }}
                          />
                        </div>

                        {/* Dropdown panel */}
                        {showAccountMenu && (
                          <ul
                            style={{
                              position: "absolute",
                              top: "calc(100% + 4px)",
                              right: 0,
                              minWidth: "260px",
                              background: "#fff",
                              border: "1px solid #e0e6ed",
                              borderRadius: "12px",
                              boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                              zIndex: 9999,
                              padding: "8px 0",
                              listStyle: "none",
                              margin: 0,
                            }}
                          >
                            {/* Account — hover submenu with company list */}
                            <li style={{ position: "relative" }}>
                              {/* Trigger row */}
                              <span
                                className="dropdown-item"
                                style={{ fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                onMouseEnter={openAccountSub}
                                onMouseLeave={closeAccountSub}
                                onClick={(e) => { e.stopPropagation(); setShowAccountSubmenu((s) => !s); if (!showAccountSubmenu) fetchLiveCompanies(); }}
                              >
                                <span>
                                  <i className="fa fa-building-o" style={{ color: "#a3a7ad", fontSize: 15 }} />
                                  &nbsp; Account
                                </span>
                                <i className="fa fa-chevron-left" style={{ fontSize: 10, color: "#adb5bd" }} />
                              </span>

                              {/* Submenu panel — shown via React state, not CSS hover */}
                              {showAccountSubmenu && (
                                <ul
                                  onMouseEnter={openAccountSub}
                                  onMouseLeave={closeAccountSub}
                                  style={{
                                    position: "absolute",
                                    right: "100%",
                                    top: 0,
                                    minWidth: "240px",
                                    margin: 0,
                                    padding: "6px 0",
                                    listStyle: "none",
                                    border: "1px solid #e9ecef",
                                    borderRadius: "6px",
                                    boxShadow: "0 8px 18px rgba(0,0,0,0.08)",
                                    background: "#fff",
                                    zIndex: 2000,
                                  }}
                                >
                                  {/* Submenu header */}
                                  <li style={{ padding: "6px 16px 4px", borderBottom: "1px solid #f0f0f0" }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                      <div style={{ fontWeight: 700, fontSize: 12, color: "#245C7F" }}>My Accounts</div>
                                      <img
                                        src="https://img.icons8.com/fluency-systems-regular/20/users-settings.png"
                                        alt="Subscription"
                                        title="Manage"
                                        style={{ width: 25, height: 25, cursor: "pointer" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setShowAccountMenu(false);
                                          setShowAccountSubmenu(false);
                                          navigate("/subscription");
                                        }}
                                      />
                                    </div>
                                    <div style={{ fontSize: 11, color: "#6c757d" }}>{activeCompanyName}</div>
                                  </li>
                                  {switchError && (
                                    <li style={{ padding: "6px 16px", background: "#fff3f3", borderBottom: "1px solid #ffc0c0" }}>
                                      <div style={{ fontSize: 11, color: "#dc3545", display: "flex", alignItems: "center", gap: 5 }}>
                                        <i className="fa fa-exclamation-circle" />
                                        {switchError}
                                      </div>
                                    </li>
                                  )}
                                  {loadingCompanies ? (
                                    <li style={{ padding: "8px 16px", fontSize: 13, color: "#adb5bd" }}>
                                      <i className="fa fa-spinner fa-spin" style={{ marginRight: 6 }} />
                                      Loading…
                                    </li>
                                  ) : accessibleCompanies.length === 0 ? (
                                    <li style={{ padding: "8px 16px", fontSize: 13, color: "#adb5bd" }}>
                                      No other companies
                                    </li>
                                  ) : (
                                    accessibleCompanies.map((c) => {
                                      const isActive  = String(c.company_id) === String(localStorage.getItem("active_company_id"));
                                      const isSelf    = c.relationship_type === "self";
                                      const isParent  = c.relationship_type === "parent";
                                      const isSibling = c.relationship_type === "sibling";
                                      const notClickable = isActive || isSelf;
                                      return (
                                        <li key={c.company_id}>
                                          <span
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              padding: "7px 16px",
                                              fontSize: 13,
                                              cursor: notClickable ? "default" : "pointer",
                                              fontWeight: isActive ? 700 : 400,
                                              background: isActive ? "#e8f0fe" : "transparent",
                                              color: "#344767",
                                            }}
                                            onMouseEnter={(e) => { if (!notClickable) e.currentTarget.style.background = "#f8f9fa"; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.background = isActive ? "#e8f0fe" : "transparent"; }}
                                            onClick={(e) => { e.stopPropagation(); if (!notClickable) { setShowAccountMenu(false); setShowAccountSubmenu(false); handleSwitchCompany(c.company_id); } }}
                                          >
                                            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                              {isParent  && <i className="fa fa-level-up"  style={{ fontSize: 10, color: "#888" }} title="Parent company" />}
                                              {isSibling && <i className="fa fa-exchange" style={{ fontSize: 10, color: "#888" }} title="Sibling company" />}
                                              {c.company__company_name}
                                            </span>
                                            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                              {isActive  && <i className="fa fa-check" style={{ fontSize: 11, color: "#245C7F" }} />}
                                              {!isActive && isParent  && <small style={{ color: "#adb5bd", fontSize: 10 }}>parent</small>}
                                              {!isActive && isSibling && <small style={{ color: "#adb5bd", fontSize: 10 }}>sibling</small>}
                                            </span>
                                          </span>
                                        </li>
                                      );
                                    })
                                  )}
                                </ul>
                              )}
                            </li>

                            <li>
                              <hr style={{ margin: "6px 0", borderColor: "#f0f0f0" }} />
                            </li>

                            {/* Settings */}
                            {customerPermission !== "Customer" && (
                              <li>
                                <span
                                  className="dropdown-item"
                                  onClick={() => { setShowAccountMenu(false); handleShow(); }}
                                  style={{ fontSize: 13, cursor: "pointer" }}
                                >
                                  <img src={process.env.PUBLIC_URL + "/static/images/ic-settings.svg"} alt="setting" />
                                  &nbsp; Settings
                                </span>
                              </li>
                            )}

                            {/* Users */}
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/user"
                                style={{ fontSize: 13 }}
                                onClick={() => setShowAccountMenu(false)}
                              >
                                <img src={process.env.PUBLIC_URL + "/static/images/ic-user.svg"} alt="User" />
                                &nbsp; Users
                              </Link>
                            </li>

                            {/* Support */}
                            <li>
                              <div className="dropdown-item" style={{ fontSize: 13 }}>
                                {customerPermission === "Customer" ? (
                                  <span
                                    style={{ cursor: "pointer", display: "block" }}
                                    onClick={() => { setShowAccountMenu(false); handleNewTicketClick(); }}
                                  >
                                    <ConfirmationNumberIcon style={{ color: "#a3a7ad", fontSize: 18 }} />
                                    &nbsp; Support
                                  </span>
                                ) : (
                                  <div
                                    className={`support-hover-dropdown w-100 ${showSupportSubmenu ? "support-open" : ""}`}
                                  >
                                    <span
                                      tabIndex="0"
                                      style={{ cursor: "pointer", display: "block" }}
                                      onClick={(e) => { e.stopPropagation(); setShowSupportSubmenu((s) => !s); }}
                                    >
                                      <ConfirmationNumberIcon style={{ color: "#a3a7ad", fontSize: 18 }} />
                                      &nbsp; Support
                                    </span>
                                    <ul className="support-submenu list-unstyled mb-0">
                                      <li className="mb-1">
                                        <span className="dropdown-item border-radius-md" style={{ cursor: "pointer", color: "#344767" }}
                                          onClick={(e) => { e.stopPropagation(); setShowAccountMenu(false); handleNewTicketClick(); }}>
                                          Support Portal
                                        </span>
                                      </li>
                                      <li className="mb-1">
                                        <Link className="dropdown-item border-radius-md" to="/user-guide" style={{ color: "#344767" }}
                                          onClick={() => setShowAccountMenu(false)}>
                                          User Guide
                                        </Link>
                                      </li>
                                      <li className="mb-1" style={isApiDisabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
                                        {isApiDisabled ? (
                                          <span className="dropdown-item border-radius-md" style={{ cursor: "not-allowed", color: "#344767" }}
                                            title="Upgrade plan to access API Integration">
                                            Integration Guide <span style={{ fontSize: 12 }}>🔒</span>
                                          </span>
                                        ) : (
                                          <Link className="dropdown-item border-radius-md" to="/api-guide" style={{ color: "#344767" }}
                                            onClick={() => setShowAccountMenu(false)}>
                                            Integration Guide
                                          </Link>
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </li>

                            <li>
                              <hr style={{ margin: "6px 0", borderColor: "#f0f0f0" }} />
                            </li>

                            {/* Logout */}
                            <li>
                              <span
                                className="dropdown-item text-danger"
                                style={{ fontSize: 13, cursor: "pointer" }}
                                onClick={() => { setShowAccountMenu(false); logOut(); }}
                              >
                                <i className="fa fa-solid fa-power-off" />
                                &nbsp; Logout
                              </span>
                            </li>
                          </ul>
                        )}
                      </li>
                      </>
                    )}

                  {/* ) : (
                    ""
                  )} */}
                  {/* 
                    OLD NOTES PANEL RENDERING LOGIC (COMMENTED)
                  {customerPermission !== "Customer" && isSidePanelOpen && (
                    // Home page: open NotesAll only if triggered from dropdown
                    path.pathname === '/' && notesFromDropdown ? (
                      <NotesAll
                        setIsSidePanelOpen={setIsSidePanelOpen}
                        setSelectedValue={setSelectedValue}
                        setOptions2={setOptions2}
                        setState={setState}
                        isSidePanelOpen={isSidePanelOpen}
                        options2={options2}
                        selectedValue={selectedValue}
                        state={state}
                      />
                    ) : (
                      // Other pages: common logic as before
                      path.pathname === '/party/details' ||
                      path.pathname === '/editparty' ||
                      path.pathname === '/editloancontract' ||
                      path.pathname === '/contract/view' ||
                      path.pathname === '/contract/edit' ||
                      path.pathname === '/editrentalcontract' ||
                      path.pathname === '/receipts/viewreceipts' ||
                      path.pathname === '/receipts/editreceipts' ||
                      path.pathname === '/billing/viewinvoices' ||
                      path.pathname === '/billing/editinvoices' ?
                        <NotesSingle
                          setIsSidePanelOpen={setIsSidePanelOpen}
                          isSidePanelOpen={isSidePanelOpen}
                          state={customData.object_id}
                          object_name={customData.object_name}
                        /> : ''
                    )
                  )}
                  */}
                  {/* 
                    NEW NOTES PANEL RENDERING LOGIC FOR ALL PAGES 
                  */}
                  {customerPermission !== "Customer" &&
                    isSidePanelOpen &&
                    (notesPanelType === "all" ? (
                      <NotesAll
                        setIsSidePanelOpen={setIsSidePanelOpen}
                        setSelectedValue={setSelectedValue}
                        setOptions2={setOptions2}
                        setState={setState}
                        isSidePanelOpen={isSidePanelOpen}
                        options2={options2}
                        selectedValue={selectedValue}
                        state={state}
                      />
                    ) : notesPanelType === "single" ? (
                      <NotesSingle
                        setIsSidePanelOpen={setIsSidePanelOpen}
                        isSidePanelOpen={isSidePanelOpen}
                        state={customData.object_id}
                        object_name={customData.object_name}
                      />
                    ) : null)}
                  {/* END NOTES PANEL RENDERING LOGIC */}

                  {/* {customerPermission !== "Customer" && (
                    <div className="cursor-pointer" onClick={handleShow}>
                      <Tooltip position="bottom" title="Settings">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/static/images/ic-settings.svg"
                          }
                          alt="setting"
                        ></img>
                      </Tooltip>
                    </div>
                  )} */}
                  {/* NEW BLUE TICKET BUTTON - ALWAYS VISIBLE */}
                  {/* {customerPermission === "Customer" ? (
                    // 👉 Show this ONLY for Customer
                    <div
                      className="cursor-pointer"
                      onClick={handleNewTicketClick}
                      style={{ marginRight: "6px" }}
                    >
                      <Tooltip position="bottom" title="Support Portal">
                        <ConfirmationNumberIcon
                          style={{ color: "#a3a7ad", marginLeft: "6px" }}
                        />
                      </Tooltip>
                    </div>
                  ) : (
                    // 👉 Show this when NOT Customer
                    <li className="nav-item dropdown d-sm-block pe-2 px-2 d-flex align-items-center">
                      <span
                        className="nav-link text-body p-0"
                        id="supportMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{ cursor: "pointer" }}
                      >
                        <Tooltip position="bottom" title="Support">
                          <ConfirmationNumberIcon
                            style={{ color: "#a3a7ad", marginLeft: "6px" }}
                          />
                        </Tooltip>
                      </span>

                      <ul
                        className="dropdown-menu px-2 py-3 ms-sm-n4"
                        aria-labelledby="supportMenuButton"
                      >
                        <li className="mb-2">
                          <span
                            className="dropdown-item border-radius-md"
                            onClick={handleNewTicketClick}
                          >
                            Support Portal
                          </span>
                        </li>

                        <li className="mb-2">
                          <Link className="dropdown-item border-radius-md" to="/user-guide">
                            User Guide
                          </Link>
                        </li>
                        <li className="mb-2"style={isApiDisabled ? { 
                              opacity: 0.5, 
                              cursor: 'not-allowed',
                              pointerEvents: 'auto' // Allows the tooltip/cursor to show even if disabled
                            } : {}}
                          >
                            {isApiDisabled ? (
                              // If disabled: Show a plain span that doesn't go anywhere
                              <span 
                                className="dropdown-item border-radius-md" 
                                style={{ cursor: 'not-allowed' }}
                                title="Upgrade plan to access API Integration"
                              >
                                Integration Guide <span style={{fontSize: '12px'}}>🔒</span>
                              </span>
                            ) : (
                              // If enabled: Show the actual Link
                              <Link className="dropdown-item border-radius-md" to="/api-guide">
                                Integration Guide
                              </Link>
                            )}
                          </li>
                        </ul>
                      </li>
                    )} */}

                  {/* EXISTING SUPPORT TICKET BUTTON */}
                  {/* {customerPermission !== 'Customer' &&
                    <><div
                      className="cursor-pointer"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={handleClick}
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      <Tooltip position="bottom" title="Support Ticket"
                      >
                        <ConfirmationNumberIcon
                          style={{ color: "#a3a7ad", marginLeft: "6px" }} />
                      </Tooltip>
                    </div><Model
                        setModalVisible={setModalVisible}
                        modalVisible={modalVisible} /></>
                  } */}
                  {/* <div className="ms-2">
                    {showhide === "0" ? (
                      ""
                    ) : (
                      <Link to="/user" style={{ color: "#67748e" }}>
                        <Tooltip position="bottom" title="Users">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-user.svg"
                            }
                            alt="User"
                          ></img>
                        </Tooltip>
                      </Link>
                    )}
                  </div> */}
                  {/* <div className="ms-2">
                    <Link
                      onClick={logOut}
                      to="/login"
                      style={{ color: "#67748e" }}
                    >
                      <Tooltip position="bottom" title="Logout">
                        <i className="fa fa-solid  fa-power-off"></i>
                      </Tooltip>
                    </Link>
                  </div> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navigation;
